<template>
    <div class="col-md-12 mb-4" v-if="services.length > 0">
        <div class="container-box">
            <div class="container-box-title">{{ translate.home.allServices }}</div>
            <div class="container-box-content" id="profile-page-services">
                <table>
                    <tbody>
                    <tr v-for="(servicesChunk, i) in getChunkedServices" :key="i"
                        :class="{'mobile-hidden-service': showMoreServices && i > 2}">
                        <td v-for="service in servicesChunk" :key="service.id">{{ translateService(service.title) }}</td>
                    </tr>
                    </tbody>
                    <tfoot v-if="showMoreServices && services.length > 6"
                           class="d-table-footer-group d-sm-none">
                    <tr>
                        <td colspan="2" class="text-center">
                            <u class="btn btn-rebrand-grey-outline btn-rebrand-xs w-full mt-2"
                               @click="showMoreServices = false">
                                {{ translate.account.seeMore }}
                            </u>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>

import translateMixin from "@/components/mixins/translateMixin";

export default {
    data() {
        return {
            showMoreServices: true,
        };
    },
    computed: {
        ...mapState(['translate']),
        getChunkedServices() {
            return _.chunk(this.services, 2);
        },
    },
    mixins: [translateMixin],
    props: {
        services: {default: []},
    },
}
</script>
